import React, { Component } from 'react';

import ApprovalOutlined from '@mui/icons-material/ApprovalOutlined';

// summary widget component
import SummaryWidget from 'components/SummaryWidget';

// services
import {fetchBookingReportsCount} from 'services/booking-reports';

export default class TotalClearanceCertificates extends Component {

  state = { count : '...' }
  
  async componentDidMount () {
    try {
      let response = await fetchBookingReportsCount('clearance-certificate', {hatcheryId : 'ALL', speciesType : 'ALL'});
      this.setState({count : response.data})
    } catch (error) {
      console.log(error);
    }
  }
  
  render() {
    return (
      <SummaryWidget 
        label = {'Total Clearance Certificates'} 
        count = {this.state.count} 
        icon = {<ApprovalOutlined />}
        url = { '/aqf/bookings/test-reports/clearance-certificate' }
      />
    );
  }
}